import {
  AttachMoney as AttachMoneyIcon,
  Email as EmailIcon,
  HelpOutline as HelpOutlineIcon,
} from '@mui/icons-material';
import { Box, InputLabel, Popover, Stack, Typography, Grid, Radio, Card } from '@mui/material';
import { useState } from 'react';

const ImageGenerationTypeComponent = ({
  brandDetails,
  selectedPostGenerationType,
  handlePostGenerationType,
}) => {
  const PostGenerationTypes = [
    { label: 'Prompt to Image', value: 'prompt_to_image' },
    { label: 'Blog to Image', value: 'blog_to_image' },
    // { label: 'Image to Image (COMING SOON)', value: 'image_to_image' },
    { label: 'Edit Image', value: 'edit_image' },
  ];
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);
  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
        <Typography variant="subtitle1">Post Generation Type</Typography>

        <Box sx={{ display: 'flex', gap: 2 }}>
          <InputLabel variant="subtitle1">AI Content Credits: {brandDetails?.ai_tokens / 100}</InputLabel>

          <Box sx={{ display: 'flex' }}>
            <InputLabel variant="subtitle1">AI Image Credits: {brandDetails?.ai_image_credits}</InputLabel>

            {brandDetails?.ai_image_credits === 0 && (
              <Box
                onMouseEnter={handlePopoverOpen}
                onMouseLeave={handlePopoverClose}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  color: 'warning.main',
                  ml: 0.5,
                  cursor: 'help',
                }}
              >
                <HelpOutlineIcon fontSize="small" sx={{ mr: 0.5 }} />
                <Typography variant="caption" sx={{ fontWeight: 500 }}>
                  Low balance
                </Typography>
              </Box>
            )}
            <Popover
              open={open}
              anchorEl={anchorEl}
              onClose={handlePopoverClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              disableRestoreFocus
              sx={{ pointerEvents: 'none' }}
              PaperProps={{
                sx: {
                  p: 1.5,
                  px: 2,
                  borderRadius: 2,
                  boxShadow: 4,
                  pointerEvents: 'auto',
                  bgcolor: 'background.paper',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                },
              }}
            >
              <Stack direction="row" spacing={1} alignItems="center">
                <EmailIcon fontSize="small" color="primary" />
                <Typography variant="body2" sx={{ whiteSpace: 'nowrap' }}>
                  Please contact <strong>support@brand2social.com</strong>
                </Typography>
              </Stack>
              <Stack direction="row" spacing={1} alignItems="center">
                <AttachMoneyIcon fontSize="small" color="primary" />
                <Typography variant="body2" sx={{ whiteSpace: 'nowrap' }}>
                  <strong>50 Credits for $10</strong>
                </Typography>
              </Stack>
            </Popover>
          </Box>
        </Box>
      </Box>
      <Grid container spacing={2}>
        {PostGenerationTypes?.map((type) => {
          const isSelected = type.value === selectedPostGenerationType;
          return (
            <Grid item xs={12} md={6} key={type.value}>
              <Card
                onClick={() => {
                  handlePostGenerationType(type.value);
                }}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  px: 2,
                  py: 1.5,
                  cursor: 'pointer',
                  border: isSelected ? '2px solid' : '1px solid',
                  borderColor: isSelected ? 'primary.main' : 'divider',
                  boxShadow: isSelected ? 3 : 1,
                  '&:hover': {
                    boxShadow: 3,
                  },
                  opacity: 1,
                }}
              >
                <Typography>{type.label}</Typography>
                <Radio checked={isSelected} />
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </>
  );
};
export default ImageGenerationTypeComponent;
